<template>
  <div class="m-toolbar">
    <div class="m-toolbar-title">{{ title }}</div>
    <slot />
  </div>
</template>

<script lang="ts" setup>
defineProps({
  title: String,
});
</script>
<style lang="scss">
.m-toolbar {
  display: flex;
  flex: 1 1 auto;

  .m-toolbar-title {
    flex: 1 1 auto;
    font-family: Georgia;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 125%;
    /* identical to box height, or 30px */

    display: flex;
    align-items: center;
    text-transform: capitalize;

    color: var(--text-color);
  }
}
</style>
